import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';

// Components
import { LanguageDropdownComponent } from './components/language-dropdown/language-dropdown.component';
import { LanguageHorizontalComponent } from './components/language-horizontal/language-horizontal.component';

// Pipe
import { TranslatePipe } from '../shared/pipes/translate/translate.pipe';

// Services
import { TranslationService } from './services/translation.service';
import { TRANSLATION_PROVIDERS } from './translation';

@NgModule({
  declarations: [
    TranslatePipe,
    LanguageDropdownComponent,
    LanguageHorizontalComponent
  ],
  imports: [CommonModule],
  exports: [
    TranslatePipe,
    LanguageDropdownComponent,
    LanguageHorizontalComponent
  ],
  providers: [TRANSLATION_PROVIDERS]
})

export class TranslationModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: TranslationModule,
      providers: [TranslationService]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/translation/translation.module.ts